const getLocaleFromBrowser = () =>
  typeof navigator !== 'undefined'
    ? navigator.language === 'ja'
      ? 'ja-JP'
      : navigator.language
    : ''

export default getLocaleFromBrowser
